// extracted by mini-css-extract-plugin
export default {"infoModal":"infoModal_infoModal__y3aYb","closeBtn":"infoModal_closeBtn__GoHJQ"};